import React from 'react'
import { Center, Loader } from '@mantine/core'
import { useViewportSize } from '@mantine/hooks'

const LoadingData = () => {
  const { height } = useViewportSize()
  return (
    <Center h={height / 2}>
      <Loader size='md' type='dots' />
    </Center>
  )
}

export default LoadingData